import { Box } from '@startuptools/ui/Box';
import { Typography } from '@startuptools/ui/Typography';
import { ComponentProps } from 'react';

export const DocumentPreview = ({
  name,
  children,
  sx,
  ...rest
}: { name: React.ReactNode } & ComponentProps<typeof Box>) => {
  return (
    <Box
      sx={{
        width: 120,
        height: 160,
        backgroundColor: 'white',
        fontWeight: 'bold',
        fontSize: '1.5rem',
        border: '1px solid #ccc',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        boxShadow: 3,
        flexShrink: 0,
        gap: 1,
        borderRadius: '5%',
        transition: 'all 0.15s ease',
        ...sx,
      }}
      {...rest}
    >
      <Typography level="body-sm">{name}</Typography>
      {children}
    </Box>
  );
};
